export const PAGE_TYPE = {
    educatedInvestor: 'educated-investor',
    reports: 'reports',
    fabricReports: 'fabric-reports',
    fileDownloads: 'file-downloads',
    default: 'default',
};

export const EI_PAGES = {
    fullAndex: 'ei-full-andex',
    percentageReturns: 'ei-percentage-returns',
    past30Years: 'ei-past-30-years',
};

export const REPORTS_PAGES = {
    dashboard: 'dashboard',
    userRegistrations: 'user-registrations',
    userLogins: 'user-logins',
    userIngressAggregate: 'user-ingress-aggregate',
    userCourses: 'user-courses',
    userCoursesAggregate: 'user-courses-aggregate',
    userAnswers: 'user-answers',
    userResources: 'user-resources',
    userCheckups: 'user-checkups',
    userCheckupsAggregate: 'user-checkups-aggregate',
    userMeditations: 'user-meditations',
    userCallsToAction: 'user-calls-to-action',
    userCallsToActionAggregate: 'user-calls-to-action-aggregate',
    userSearches: 'user-searches',
    userStressChange: 'user-stress-change',
    userStressAggregate: 'user-stress-aggregate',
    userGamificationAggregate: 'user-gamification-aggregate',
    userFinancialWellnessChange: 'user-financial-wellness-change',
    userFeedback: 'user-feedback',
    userSproutsEarned: 'user-sprouts-earned',
    userSproutsRedeemed: 'user-sprouts-redeemed',
    userCreditEnrollment: 'user-credit-enrollment',
    userCreditAggregate: 'user-credit-aggregate',
    userXp: 'user-xp',
    userJournals: 'user-journals',
    userMoneyMindfulness: 'user-money-mindfulness',
    userMindfulnessAggregate: 'user-mindfulness-aggregate',
    userAiConversations: 'user-ai-conversations',
    userAiAggregate: 'user-ai-aggregate',
    userMoneyPersonality: 'user-money-personality',
    userMoneyPersonalityAggregate: 'user-money-personality-aggregate',
    userReportCard: 'user-report-card',
    usageSummary: 'usage-summary',
};

// Each group becomes its own collapsible MenuBlock in the sidebar.
// `displayName: null` means retain the name from the API.
// Reports are rendered in the order listed here.
export const REPORT_GROUPS = [
    {
        key: 'dashboards',
        title: 'Dashboards',
        reports: [
            { slug: REPORTS_PAGES.dashboard, displayName: 'Impact' },
            { slug: REPORTS_PAGES.userFeedback, displayName: null },
        ],
    },
    {
        key: 'activity',
        title: 'Activity',
        reports: [
            { slug: REPORTS_PAGES.userReportCard, displayName: null },
            { slug: REPORTS_PAGES.usageSummary, displayName: 'Activity Summary (Aggregate)' },
            { slug: REPORTS_PAGES.userIngressAggregate, displayName: 'User Entry Points (Aggregate)' },
            { slug: REPORTS_PAGES.userRegistrations, displayName: 'User Registrations (User Detail)' },
            { slug: REPORTS_PAGES.userLogins, displayName: 'User Logins (User Detail)' },
            { slug: REPORTS_PAGES.userCallsToActionAggregate, displayName: 'Calls to Action (Aggregate)' },
            { slug: REPORTS_PAGES.userCallsToAction, displayName: 'Calls to Action (User Detail)' },
            { slug: REPORTS_PAGES.userCreditAggregate, displayName: 'Credit Score & Report (Aggregate)' },
            { slug: REPORTS_PAGES.userCreditEnrollment, displayName: 'Credit Score & Report (User Detail)' },
            { slug: REPORTS_PAGES.userSearches, displayName: 'Search Activity (User Detail)' },
        ],
    },
    {
        key: 'assessments',
        title: 'Assessments',
        reports: [
            { slug: REPORTS_PAGES.userCheckupsAggregate, displayName: 'Financial Checkup Activity (Aggregate)' },
            { slug: REPORTS_PAGES.userCheckups, displayName: 'Financial Checkup Activity (User Detail)' },
            { slug: REPORTS_PAGES.userFinancialWellnessChange, displayName: 'Financial Checkup Results (User Detail)' },
            { slug: REPORTS_PAGES.userStressAggregate, displayName: 'Financial Stress Score (Aggregate)' },
            { slug: REPORTS_PAGES.userStressChange, displayName: 'Financial Stress Score (User Detail)' },
            { slug: REPORTS_PAGES.userMoneyPersonalityAggregate, displayName: 'Your Money Personality \u00AE (Aggregate)' },
            { slug: REPORTS_PAGES.userMoneyPersonality, displayName: 'Your Money Personality \u00AE (User Detail)' },
        ],
    },
    {
        key: 'education',
        title: 'Education',
        reports: [
            { slug: REPORTS_PAGES.userAiAggregate, displayName: 'Conversational AI (Aggregate)' },
            { slug: REPORTS_PAGES.userAiConversations, displayName: 'Conversational AI (User Detail)' },
            { slug: REPORTS_PAGES.userCoursesAggregate, displayName: 'Courses (Aggregate)' },
            { slug: REPORTS_PAGES.userCourses, displayName: 'Courses (User Detail)' },
            { slug: REPORTS_PAGES.userResources, displayName: 'Content and Resources (User Detail)' },
        ],
    },
    {
        key: 'gamification',
        title: 'Gamification',
        reports: [
            { slug: REPORTS_PAGES.userGamificationAggregate, displayName: 'Gamification (Aggregate)' },
            { slug: REPORTS_PAGES.userXp, displayName: 'Experience Points (XP) (User Detail)' },
            { slug: REPORTS_PAGES.userSproutsEarned, displayName: 'Sprouts / Coins Earned (User Detail)' },
            { slug: REPORTS_PAGES.userSproutsRedeemed, displayName: 'Sprouts / Coins Redeemed (User Detail)' },
        ],
    },
    {
        key: 'mindfulness',
        title: 'Mindfulness',
        reports: [
            { slug: REPORTS_PAGES.userMindfulnessAggregate, displayName: 'Money Mindfulness (Aggregate)' },
            { slug: REPORTS_PAGES.userMeditations, displayName: 'Meditations (User Detail)' },
            { slug: REPORTS_PAGES.userJournals, displayName: 'Journaling (User Detail)' },
            { slug: REPORTS_PAGES.userMoneyMindfulness, displayName: '8-Week Program (User Detail)' },
        ],
    },
];

export const FILE_DOWNLOAD_PAGES = {
    counselingReports: 'counseling-reports',
};

export const FABRIC_REPORTS = {
    financialWellnessChange: 'fabric-financial-wellness-change',
};

// Some notes about likely origins of the errors for posterity:
// reportRequest error - User would be fully authed and already have other
//                       successful requests so most likely an issue downstream of the ReportsController
// token error - Getting the token from Auth0. Likely misconfigured Auth0 account or issue on their side
// cobrands error - Problem reaching API server or user account misconfigured
// claims error - Problem reaching API server or user account misconfigured
// generic error - ¯\_(ツ)_/¯
export const ERROR_TEXT = {
    reportRequest:
        'There was a problem loading the report. Please refresh and try again.',
    reportsMeta:
        'There was a problem initializing the reports. Please refresh and try again.',
    token: 'There was a problem with your credentials. Please refresh and try again.',
    cobrands:
        'There was a problem getting your Cobrand access. Please refresh and try again.',
    claims: 'There was a problem validating your account. Please refresh and try again.',
    generic:
        'There was a communication error with our servers. Please refresh and try again.',
};
